
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-resetexec");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/resetexec/index.js
// module id = iHG/
// module chunks = 11